<div class="auth-login-form-container mb-5">
  <div class="flex flex-col gap-4 sm:w-[400px] sm:gap-6">
    <button
      class="back-button flex w-fit items-center gap-[6px] p-2 pl-0 text-brand-primary-800"
      type="button"
      (click)="goBack()"
    >
      <aw-icon class="w-5" icon="arrow-left" />
      <span class="font-medium">Back</span>
    </button>

    <div class="flex w-full flex-col gap-2 sm:w-[300px]">
      <p class="text-[18px] font-medium leading-6 text-brand-primary-800">
        Welcome back!
      </p>
      <h2 class="text-2xl font-medium leading-9 text-brand-accent-400">
        What’s your registered email address?
      </h2>
    </div>

    <form class="w-full" [formGroup]="loginForm" (ngSubmit)="submitForm()">
      <div class="mb-4 flex w-full flex-col gap-y-5">
        <!-- Email Field -->
        <aw-form-field class="flex w-full flex-col">
          <aw-input
            name="email"
            placeholder="Email address"
            formControlName="email"
            inputmode="email"
            autocomplete="email"
            autofocus="true"
            type="email"
            [isShowDirhamIcon]="false"
          />

          @if (loginForm.get('email')?.errors?.['required']) {
            <aw-form-field-error>
              The email address is required
            </aw-form-field-error>
          } @else if (loginForm.get('email')?.errors?.['email']) {
            <aw-form-field-error>
              Please enter a valid email address
            </aw-form-field-error>
          }
        </aw-form-field>
      </div>

      <!-- Email Provider Suggestions -->
      <div
        class="mb-10 flex flex-wrap gap-2 opacity-100 transition duration-200 ease-in"
        [ngClass]="{ 'pointer-events-none !opacity-0': !showEmailProviders() }"
      >
        @for (provider of emailProviders; track provider) {
          <button
            class="rounded-full border border-po-gray-50 bg-white px-4 py-1 text-sm text-brand-accent-400 transition-colors hover:border-brand-accent-400 hover:bg-brand-accent-400 hover:text-white"
            type="button"
            (click)="selectEmailProvider(provider)"
          >
            {{ provider }}
          </button>
        }
      </div>

      <po-button
        class="btn-submit inline-block w-full"
        variant="authSubmit"
        businessUnit="blocks"
        buttonText="Continue"
        type="submit"
        [loading]="isSubmitting() || hasSession()"
        [disabled]="loginForm.invalid"
      >
        <span>Continue</span>
      </po-button>
    </form>

    <div
      class="mt-14 flex flex-row items-center gap-2 text-left text-brand-accent-400"
    >
      <span class="text-left">Don't have an account yet?</span>

      <po-button
        class="mx-2 inline-block w-fit"
        buttonText="Sign up"
        variant="primary-outline"
        size="small"
        [path]="registerRoute"
        [disabled]="isSubmitting()"
        (clicked)="onSignUp('Sign up')"
        >Sign up</po-button
      >
    </div>

    <!-- Error Display -->
    <ng-container [ngTemplateOutlet]="authErrorsTemplate" />
  </div>
</div>

<ng-template #authErrorsTemplate>
  @if (error$ | async; as error) {
    @if (error?.message) {
      <div class="rounded-lg bg-po-grey-6/85 p-2 text-sm text-po-red-400">
        {{ error.message }}
      </div>
    }
  }
</ng-template>
